import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { distinctUntilChanged, filter, first, map, shareReplay, switchMap, tap } from 'rxjs/operators'
import { isNotNullable, Product, ProductReference, ProductReferenceService } from '@spartacus/core'
import { DataAnalyticsClickSource, DataAnalyticsEventLabel, MbConstants, } from '../../../../shared/mb-constants'
import { OrderEntry } from '@spartacus/cart/base/root'
import { Observable, of, Subscription } from 'rxjs'

@Component({
  selector: 'mb-add-to-cart-dialog-teaser-component',
  templateUrl: './add-to-cart-dialog-teaser.component.html',
  styleUrls: ['/add-to-cart-dialog-teaser.component.scss']
})
export class AddToCartDialogTeaserComponent implements OnInit, OnDestroy {

  @Input() dataAnalyticsClickSource = DataAnalyticsClickSource.UNKNOWN
  @Input() dataAnalyticsEventLabel = DataAnalyticsEventLabel.UNKNOWN
  @Input() entry: OrderEntry | undefined | null
  constants = MbConstants
  product$: Observable<Product> | undefined
  references$: Observable<ProductReference[]> | undefined
  title = 'mbproduct.doYouNeedAnythingElse'
  subscription = new Subscription()

  constructor (
    protected productReferenceService: ProductReferenceService
  ) {
  }

  ngOnInit (): void {
    this.product$ = of(this.entry?.product).pipe(
      filter(isNotNullable),
      shareReplay({ bufferSize: 1, refCount: true })
    )

    const productCode$ = this.product$.pipe(
      map(product => product?.originalCode),
      filter(isNotNullable),
      distinctUntilChanged(),
      tap((_) => this.productReferenceService.cleanReferences())
    )
    this.references$ = productCode$.pipe(
      switchMap(productCode => this.productReferenceService.getProductReferences(productCode, this.constants.RELATED).pipe(
        filter(references => references.length !== 0),
        /* this first() is crucial because the product references store only stores one instance of references, which
         * is always the most recently requested ones. We have to "disconnect" from the store after the first emit. */
        first()
      )),
    )

    this.subscription?.add(productCode$.subscribe(
      productCode => this.productReferenceService.loadProductReferences(productCode, this.constants.RELATED)
    ))
  }
  ngOnDestroy (): void {
    this.subscription.unsubscribe()
  }
}
